define('common/helpers/load-user-data',['app'], function(app) {
    'use strict';

    function processResults(results) {
        var userData = null;
        var productSettings = null;

        // One or both of these requests can fail; continue with
        // whatever data we received.
        if (results[0].status === 'fulfilled') {
            userData = results[0].value;
            app.initData.set('user', userData);
        }

        if (results[1].status === 'fulfilled') {
            productSettings = results[1].value;
            // Merge - init_data may already carry the full settings set; don't drop it.
            app.initData.set('product_settings', _.extend(
                {},
                app.initData.get('product_settings') || {},
                productSettings.reduce(function(acc, setting) {
                    acc[setting.code] = setting.value;
                    return acc;
                }, {})
            ));
        }

        return { 'userData': userData, 'productSettings': productSettings };
    }

    function checkSessionState() {
        var eddeApiRoot = window.paths ? window.paths.api : '';

        // Edde doesn't add user data to error routes (see SRE-988)
        // so try to load it now

        if (!eddeApiRoot) {
            return Promise.reject(new Error('No API root available'));
        }

        return fetch(
            eddeApiRoot + '/v1/users/session_state',
            {
                'credentials': 'include',
                'headers': {
                    'X-Request-Deadline': 's=2.5'
                },
                'referrerPolicy': 'no-referrer-when-downgrade'
            }
        ).then(function(response) {
            if (response.ok) {
                return response.json().then(function(data) {
                    if (data.session_status === 'logged_in') {
                        // The user is logged in; we can keep requesting data
                        var userDataPromise = fetchUserData(eddeApiRoot);
                        var productSettingsPromise = fetchProductSettings(eddeApiRoot);

                        return Promise.allSettled([userDataPromise, productSettingsPromise]).then(processResults);
                    } else {
                        throw new Error('User not logged in');
                    }
                });
            } else {
                throw new Error('Failed to check session state');
            }
        });
    }

    function fetchProductSettings(eddeApiRoot) {
        var codes = [
            'SHARING',
            'ALLOWSTUDIO',
            'HIDEPROFILE',
            'ENABLESTUDENTPROFILE',
            'SHOWSEARCH',
            'STUDENTSERACH', // no this isn't a typo
            'HIDE_MY_FAVORITES',
            'SHOW_GLOBAL_NAV_2023'
        ];

        return fetch(
            eddeApiRoot + '/v1/users/product_settings?' + codes
                .map(function(code) {
                    return 'codes=' + code;
                }).join('&'),
            {
                'credentials': 'include',
                'headers': {
                    'X-Request-Deadline': 's=2.5'
                },
                'referrerPolicy': 'no-referrer-when-downgrade'
            }
        ).then(function(response) {
            if (response.ok) {
                return response.json().then(function(data) {
                    return data.settings;
                });
            } else {
                throw new Error('Failed to fetch product settings');
            }
        });
    }

    function fetchUserData(eddeApiRoot) {
        return fetch(
            eddeApiRoot + '/v1/users/me?return_avatar=true&return_theme=true',
            {
                'credentials': 'include',
                'headers': {
                    'X-Request-Deadline': 's=2.5'
                },
                'referrerPolicy': 'no-referrer-when-downgrade'
            }
        ).then(function(response) {
            if (response.ok) {
                return response.json().then(function(data) {
                    if (data.user) {
                        return _.extend(
                            {},
                            data.user,
                            {
                                // These properties appear differently in the users/me response than
                                // they do in initData.user
                                'is_impersonation': data.impersonation && data.impersonation.impersonated,
                                'is_student': data.user.roles.some(function(role) { return role.code === 'STUDENT'; })
                            }
                        );
                    } else {
                        throw new Error('No user data in response');
                    }
                });
            } else {
                throw new Error('Failed to fetch user data');
            }
        });
    }

    return checkSessionState;
});

